import Vue from 'vue';
import TAC from '@/components/TAC';

const TACPlugin = {
	install(Vue) {
		const TACConstructor = Vue.extend(TAC);
		const instance = new TACConstructor();
		instance.$mount(document.createElement('div'));
		document.body.appendChild(instance.$el);

		Vue.prototype.$showCaptcha = function() {
			return instance.show(); // 返回 Promise
		};
	}
};

export default TACPlugin;